module.exports = __webpack_public_path__ + "img/Nicotiana_benthamiana.f91b7a5e.jpg";